import ApiService from '~/util/apiService';

export const getNav = () => {
  return ApiService.get<string>('/website-nav/web-api/legacyNav');
};
